<app-complex-modal-template
    [canConfirm]="statisticForm()!.valid"
    [stepNumber]="1"
    [title]="data.title | transloco"
    (onClickEvent)="onClickEvent($event)">
    <form [formGroup]="statisticForm()!">
        <div class="flex flex-col">
            <div class="flex flex-row gap-4 w-full items-center">
                <div
                    class="flex flex-col min-h-2/3"
                    [class]="data.isEditMode ? 'w-full' : 'w-1/2'">
                    <app-input-text
                        [errors]="nameControl.errors ? getFormErrors(nameControl.errors) : []"
                        [inputFormControl]="nameControl"
                        [label]="`${('title' | transloco)}*`"
                        [placeholder]="'enterName' | transloco" />

                    <app-input-text
                        [errors]="descriptionControl.errors ? getFormErrors(descriptionControl.errors) : []"
                        [inputFormControl]="descriptionControl"
                        [label]="'description' | transloco"
                        [placeholder]="'enterDescription' | transloco" />

                    @if (!data.isEditMode) {
                        <app-input-text
                            [errors]="orderControl.errors ? getFormErrors(orderControl.errors) : []"
                            [inputFormControl]="orderControl"
                            [label]="'order' | transloco"
                            [placeholder]="'enterOrder' | transloco" />

                        @if (isAxisConfigurationRequired()) {
                            <app-statistic-render-option [axisFormInputs]="axisFormInputs()" />
                        }
                    }
                </div>

                @if (!data.isEditMode) {
                    <div class="flex flex-col w-1/2">
                        <app-chart
                            [computedStatistic]="computedStatistic()"
                            [isExpanded]="true"
                            [showLabels]="false" />
                        <p class="text-caption text-on-surface font-normal pl-4 pt-4">
                            {{ 'statistic.statisticAdaptedToGraphicCharter' | transloco }}
                        </p>
                    </div>
                }
            </div>

            <div
                class="flex flex-row items-center gap-2 mt-4 cursor-pointer"
                (click)="toggleIsShared()">
                <app-checkbox
                    [checkboxState]="isSharedControl.value ? CheckboxState.CHECKED : CheckboxState.UNCHECKED" />
                <span>
                    {{ 'statistic.shareStatisticWithProjectUsers' | transloco }}
                </span>
            </div>
            @if (isAxisConfigurationRequired() && data.isEditMode) {
                <app-statistic-render-option [axisFormInputs]="axisFormInputs()" />
            }
        </div>
    </form>
</app-complex-modal-template>
